import { useState, useEffect, useCallback } from 'react';
import axios from '../../functions/axios';
import { useAuthContext } from '../../hooks/useAuthContext';
import { Box } from '@mui/material';
const actionType = new Map([
  ['POST', 'Dodano'],
  ['PATCH', 'Edytowano'],
  ['DELETE', 'Usunięto'],
]);
const actionTypeColor = new Map([
  ['POST', 'rgb(0, 220, 0)'],
  ['PATCH', 'rgba(132, 185, 255, 1)'],
  ['DELETE', 'rgb(220,0, 0)'],
]);
const propertyType = new Map([
  ['CARRIAGE', 'Dostawę'],
  ['CAR', 'Samochód'],
  ['CLIENT', 'Klienta'],
  ['DRIVER', 'Kierowcę'],
  ['APP_USER', 'Użytkownika'],
  ['PALETTS', 'Palety'],
  ['SOLD_CARRIAGE', 'Sprzedany transport'],
  ['NOTES', 'Notatka kierowcy'],
  ['CARRIAGE_NOTES', 'Notatka dostawy'],
]);

const AuditLog = () => {
  const [apiData, setApiData] = useState([]);
  const { user } = useAuthContext();

  const getAuditLogData = useCallback(async () => {
    if (!user) return null;

    try {
      const response = await axios.get(`/auditLog`, {
        params: {
          poll: 400,
        },
      });
      setApiData(response.data);
    } catch (error) {
      console.error(error.message);
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      getAuditLogData();
    }
  }, [user, getAuditLogData]);

  return (
    <Box style={{ color: 'white', margin: '20px' }}>
      <h2>Dziennik zdarzeń</h2>
      <br />
      <div style={{ margin: '10px' }}>
        <div
          style={{
            display: 'table',
            width: 'auto',
            borderCollapse: 'separate',
            borderSpacing: '0px 4px',
          }}
        >
          {apiData.map((data, index) => {
            return (
              <div key={index} style={{ display: 'table-row' }}>
                <div style={{ display: 'table-cell', padding: '0 15px', textAlign: 'left' }}>
                  {new Date(data.createdTimestamp).toLocaleString('pl')}
                </div>
                <div style={{ display: 'table-cell', padding: '0 15px', textAlign: 'left', color: actionTypeColor.get(data.actionType) }}>
                  {actionType.get(data.actionType)}
                </div>
                <div style={{ display: 'table-cell', padding: '0 15px', textAlign: 'left' }}>
                  {propertyType.get(data.propertyType)}
                </div>
                <div style={{ display: 'table-cell', padding: '0 15px', textAlign: 'left' }}>
                  {data.appUser?.surName}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Box>
  );
};

export default AuditLog;
